import styled from 'styled-components';

import {bodyBold, smallRegular} from '~/shared/theme/typography';
import {flipOnLTR} from '~/shared/theme/utils';

export const Header = styled.h3`
  ${bodyBold}
  color: ${({theme}) => theme.colors.contentDefault};
  ${flipOnLTR`
    text-align: right;
  `}
`;

export const Explanation = styled.span`
  display: block;
  margin-top: 4px;
  color: ${({theme}) => theme.colors.contentDefault};
  ${smallRegular}
`;
